import { AdminUser } from '@/types/admin';

interface UserStatusBadgeProps {
  status: AdminUser['activityStatus'];
}

export function UserStatusBadge({ status }: UserStatusBadgeProps) {
  const config = {
    highly_active: { label: 'Highly Active', color: 'bg-green-100 text-green-800', icon: '🟢' },
    active: { label: 'Active', color: 'bg-blue-100 text-blue-800', icon: '🔵' },
    inactive: { label: 'Inactive', color: 'bg-gray-100 text-gray-800', icon: '⚪' },
    at_risk: { label: 'At-Risk', color: 'bg-yellow-100 text-yellow-800', icon: '🟠' },
    new: { label: 'New User', color: 'bg-purple-100 text-purple-800', icon: '🆕' }
  };

  const { label, color, icon } = config[status];

  return (
    <span className={'px-2 py-1 rounded-full text-xs font-medium ' + color}>
      {icon} {label}
    </span>
  );
}
